import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, vModelRadio as _vModelRadio, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "relative bg-white shadow-md dark:bg-gray-800 sm:rounded-lg mt-6" }
const _hoisted_3 = { class: "flex flex-col items-center justify-between py-4 mx-4 space-y-3 border-b md:flex-row md:space-y-0 md:space-x-4 dark:border-gray-700" }
const _hoisted_4 = { class: "flex items-center w-full space-x-3" }
const _hoisted_5 = { class: "font-semibold dark:text-white" }
const _hoisted_6 = {
  key: 0,
  class: "font-medium text-gray-500 dark:text-gray-400"
}
const _hoisted_7 = { class: "flex flex-row items-center justify-end w-full space-x-3" }
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "relative mt-6" }
const _hoisted_10 = { class: "relative mt-4 mb-2" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = ["id", "onClick"]
const _hoisted_13 = { class: "flex justify-between items-center w-full font-medium text-left text-gray-900 dark:text-white" }
const _hoisted_14 = { class: "flex justify-between items-center w-full" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "text-sm text-gray-400 mr-4" }
const _hoisted_19 = {
  key: 0,
  class: "w-3 h-6 float-right rotate-180 shrink-0",
  fill: "none",
  height: "2",
  viewBox: "0 0 12 2",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_20 = {
  key: 1,
  class: "w-3 h-6 float-right rotate-180 shrink-0",
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "flex justify-between mt-2 mb-2" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "p-4 rounded-lg border border-gray-300" }
const _hoisted_27 = { class: "relative overflow-hidden bg-white" }
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = { class: "flex flex-row items-center justify-end w-full space-x-3" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "flex items-center" }
const _hoisted_32 = { class: "relative mr-3 inline-flex items-center justify-center w-12 h-8 overflow-hidden bg-white dark:bg-gunmetal border-[0.5px] border-gray-200" }
const _hoisted_33 = { class: "font-medium text-gray-600 dark:text-gray-300" }
const _hoisted_34 = {
  key: 0,
  class: "w-6 h-6 text-gray-800 dark:text-white",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_35 = {
  key: 1,
  class: "w-6 h-6 text-gray-800 dark:text-white",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_36 = { class: "text-black dark:text-white text-1xl" }
const _hoisted_37 = { class: "flex items-center" }
const _hoisted_38 = { class: "text-xs text-graphite dark:text-off-white" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "p-4" }
const _hoisted_42 = { class: "relative mt-6" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = {
  key: 0,
  class: "relative mt-6"
}
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 1,
  class: "relative mt-6"
}
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = {
  key: 2,
  class: "relative mt-6"
}
const _hoisted_49 = ["onChange"]
const _hoisted_50 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_51 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_52 = {
  key: 1,
  class: "text-xs text-red-600"
}
const _hoisted_53 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_54 = ["src"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 4,
  class: "mt-2 text-xs text-gray-600"
}
const _hoisted_57 = {
  key: 5,
  class: "mt-3"
}
const _hoisted_58 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_59 = {
  key: 1,
  class: "text-xs text-green-700"
}
const _hoisted_60 = {
  key: 2,
  class: "text-xs text-red-600"
}
const _hoisted_61 = {
  key: 3,
  class: "mt-2 h-2 w-full rounded-full bg-gray-200"
}
const _hoisted_62 = {
  key: 6,
  class: "relative mt-4 mb-2"
}
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { class: "flex items-center" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["disabled", "onClick"]
const _hoisted_67 = { class: "flex items-center" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "p-4" }
const _hoisted_71 = { class: "mt-6" }
const _hoisted_72 = { class: "grid w-full gap-6 md:grid-cols-2" }
const _hoisted_73 = { class: "relative mt-6" }
const _hoisted_74 = {
  key: 0,
  class: "relative mt-6"
}
const _hoisted_75 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_76 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_77 = {
  key: 1,
  class: "text-xs text-red-600"
}
const _hoisted_78 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_79 = ["src"]
const _hoisted_80 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_81 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_82 = {
  key: 1,
  class: "text-xs text-green-700"
}
const _hoisted_83 = {
  key: 2,
  class: "text-xs text-red-600"
}
const _hoisted_84 = {
  key: 3,
  class: "mt-2 h-2 w-full rounded-full bg-gray-200"
}
const _hoisted_85 = { class: "relative mt-6" }
const _hoisted_86 = { class: "relative mt-4 mb-2" }
const _hoisted_87 = {
  key: 3,
  class: "relative mt-4 mb-2"
}
const _hoisted_88 = { class: "flex items-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "p-4" }
const _hoisted_92 = { class: "relative mt-6" }
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = { class: "relative mt-4 mb-2" }
const _hoisted_95 = ["onUpdate:modelValue"]
const _hoisted_96 = { class: "flex items-center" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "flex items-center" }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[48] || (_cache[48] = _createStaticVNode("<nav aria-label=\"Breadcrumb\" class=\"flex\"><ol class=\"inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse\"><li class=\"inline-flex items-center\"><a class=\"inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white\" href=\"#\">Admin</a></li><li><div class=\"flex items-center\"><svg aria-hidden=\"true\" class=\"rtl:rotate-180 w-3 h-3 text-gray-400 mx-1\" fill=\"none\" viewBox=\"0 0 6 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m1 9 4-4-4-4\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></svg><a class=\"ms-1 text-sm font-medium text-black hover:text-primary md:ms-2 dark:text-white dark:hover:text-white\" href=\"#\">Courses</a></div></li></ol></nav>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.course.title), 1),
          (_ctx.course.modules)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.course.modules.length) + " modules. ", 1))
            : _createCommentVNode("", true),
          _cache[16] || (_cache[16] = _createElementVNode("div", { "data-tooltip-target": "results-tooltip" }, [
            _createElementVNode("svg", {
              "aria-hidden": "true",
              class: "w-4 h-4 text-gray-500 dark:text-gray-400",
              fill: "currentColor",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "clip-rule": "evenodd",
                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                "fill-rule": "evenodd"
              })
            ]),
            _createElementVNode("span", { class: "sr-only" }, "More info")
          ], -1)),
          _cache[17] || (_cache[17] = _createElementVNode("div", {
            id: "results-tooltip",
            class: "absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700",
            role: "tooltip"
          }, [
            _createTextVNode(" Showing 1-10 of 6,560 results "),
            _createElementVNode("div", {
              class: "tooltip-arrow",
              "data-popper-arrow": ""
            })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-white rounded-lg md:w-auto bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('newModule')))
          }, _cache[18] || (_cache[18] = [
            _createElementVNode("svg", {
              "aria-hidden": "true",
              class: "h-3.5 w-3.5 mr-2",
              fill: "currentColor",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "clip-rule": "evenodd",
                d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                "fill-rule": "evenodd"
              })
            ], -1),
            _createElementVNode("span", null, "New Module", -1)
          ])),
          _createVNode(_component_Modal, {
            "is-visible": _ctx.modals.newModule,
            "modal-id": "newModule",
            "onUpdate:isVisible": _cache[5] || (_cache[5] = value => _ctx.modals.newModule = value)
          }, {
            body: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
                  _createElementVNode("svg", {
                    class: "w-52",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("g", {
                      id: "SVGRepo_bgCarrier",
                      "stroke-width": "0"
                    }),
                    _createElementVNode("g", {
                      id: "SVGRepo_tracerCarrier",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }),
                    _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                      _createElementVNode("path", {
                        d: "M12.5518 8C11.9995 8 11.5518 8.44772 11.5518 9C11.5518 9.55228 11.9995 10 12.5518 10H16.5518C17.104 10 17.5518 9.55228 17.5518 9C17.5518 8.44772 17.104 8 16.5518 8H12.5518Z",
                        fill: "#000000",
                        "fill-opacity": "0.5"
                      }),
                      _createElementVNode("path", {
                        d: "M12.5518 17C11.9995 17 11.5518 17.4477 11.5518 18C11.5518 18.5523 11.9995 19 12.5518 19H16.5518C17.104 19 17.5518 18.5523 17.5518 18C17.5518 17.4477 17.104 17 16.5518 17H12.5518Z",
                        fill: "#000000",
                        "fill-opacity": "0.5"
                      }),
                      _createElementVNode("path", {
                        d: "M12.5518 5C11.9995 5 11.5518 5.44772 11.5518 6C11.5518 6.55228 11.9995 7 12.5518 7H20.5518C21.104 7 21.5518 6.55228 21.5518 6C21.5518 5.44772 21.104 5 20.5518 5H12.5518Z",
                        fill: "#000000",
                        "fill-opacity": "0.8"
                      }),
                      _createElementVNode("path", {
                        d: "M12.5518 14C11.9995 14 11.5518 14.4477 11.5518 15C11.5518 15.5523 11.9995 16 12.5518 16H20.5518C21.104 16 21.5518 15.5523 21.5518 15C21.5518 14.4477 21.104 14 20.5518 14H12.5518Z",
                        fill: "#000000",
                        "fill-opacity": "0.8"
                      }),
                      _createElementVNode("path", {
                        d: "M3.44824 4.00208C2.89596 4.00208 2.44824 4.44979 2.44824 5.00208V10.0021C2.44824 10.5544 2.89596 11.0021 3.44824 11.0021H8.44824C9.00053 11.0021 9.44824 10.5544 9.44824 10.0021V5.00208C9.44824 4.44979 9.00053 4.00208 8.44824 4.00208H3.44824Z",
                        fill: "#000000"
                      }),
                      _createElementVNode("path", {
                        d: "M3.44824 12.9979C2.89596 12.9979 2.44824 13.4456 2.44824 13.9979V18.9979C2.44824 19.5502 2.89596 19.9979 3.44824 19.9979H8.44824C9.00053 19.9979 9.44824 19.5502 9.44824 18.9979V13.9979C9.44824 13.4456 9.00053 12.9979 8.44824 12.9979H3.44824Z",
                        fill: "#000000"
                      })
                    ])
                  ]),
                  _createElementVNode("h2", { class: "block text-2xl font-bold text-gray-800 dark:text-gray-200" }, " Create New Module "),
                  _createElementVNode("p", { class: "mt-2 text-sm text-gray-600 dark:text-gray-400" }, " You are creating a new module for this course. ")
                ], -1)),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    id: "newModuleTitle",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newModule.title) = $event)),
                    class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2",
                    placeholder: "Enter the module name",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.newModule.title]
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                    for: "newModuleTitle"
                  }, "Module name", -1))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newModule.description) = $event)),
                    class: "py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                    placeholder: "Please describe this module...",
                    rows: "3"
                  }, null, 512), [
                    [_vModelText, _ctx.newModule.description]
                  ])
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal('newModule')))
                }, " Cancel "),
                _createElementVNode("button", {
                  class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createModule && _ctx.createModule(...args)))
                }, " Create ")
              ])
            ]),
            _: 1
          }, 8, ["is-visible"])
        ])
      ]),
      _createVNode(_component_draggable, {
        modelValue: _ctx.course.modules,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.course.modules) = $event)),
        class: "draggable-items",
        onChange: _ctx.orderModules
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.modules, (module, index) => {
            return (_openBlock(), _createElementBlock("div", {
              id: "draggable-course-module-accordion",
              key: index,
              class: "p-4 border-t bg-white drag-item border-gray-200"
            }, [
              _createElementVNode("div", {
                id: 'accordion-flush-heading-' + index,
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.toggleModule(module))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[21] || (_cache[21] = _createElementVNode("svg", {
                        class: "w-auto mr-1 h-6 float-right rotate-180 fill-gray-300 shrink-0",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", {
                          id: "SVGRepo_bgCarrier",
                          "stroke-width": "0"
                        }),
                        _createElementVNode("g", {
                          id: "SVGRepo_tracerCarrier",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                          _createElementVNode("path", { d: "M16 17C17.1046 17 18 17.8954 18 19C18 20.1046 17.1046 21 16 21C14.8954 21 14 20.1046 14 19C14 17.8954 14.8954 17 16 17ZM8 17C9.10457 17 10 17.8954 10 19C10 20.1046 9.10457 21 8 21C6.89543 21 6 20.1046 6 19C6 17.8954 6.89543 17 8 17ZM16 10C17.1046 10 18 10.8954 18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10ZM8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12C6 10.8954 6.89543 10 8 10ZM16 3C17.1046 3 18 3.89543 18 5C18 6.10457 17.1046 7 16 7C14.8954 7 14 6.10457 14 5C14 3.89543 14.8954 3 16 3ZM8 3C9.10457 3 10 3.89543 10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3Z" })
                        ])
                      ], -1)),
                      _createElementVNode("h2", _hoisted_16, _toDisplayString(module.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getContentCount(module)), 1),
                      (module.show)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[22] || (_cache[22] = [
                            _createElementVNode("path", {
                              d: "M0.75 1H11.25",
                              stroke: "black",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1.5"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      (!module.show)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[23] || (_cache[23] = [
                            _createElementVNode("path", {
                              d: "M6 0.75V11.25M0.75 6H11.25",
                              stroke: "black",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1.5"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 8, _hoisted_12),
              _withDirectives(_createElementVNode("div", {
                id: 'accordion-flush-body-' + index,
                class: "mt-3"
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-sm text-gray-400 ml-6" }, "Here you can view and manage the module content.", -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                      type: "button",
                      onClick: ($event: any) => (_ctx.openUpdateModuleModal(module._id))
                    }, _cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        class: "w-5 h-5 mr-2",
                        fill: "#000000",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", {
                          id: "SVGRepo_bgCarrier",
                          "stroke-width": "0"
                        }),
                        _createElementVNode("g", {
                          id: "SVGRepo_tracerCarrier",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                          _createElementVNode("title"),
                          _createElementVNode("g", { id: "Complete" }, [
                            _createElementVNode("g", { id: "edit" }, [
                              _createElementVNode("g", null, [
                                _createElementVNode("path", {
                                  d: "M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8",
                                  fill: "none",
                                  stroke: "#000000",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2"
                                }),
                                _createElementVNode("polygon", {
                                  fill: "none",
                                  points: "12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8",
                                  stroke: "#000000",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2"
                                })
                              ])
                            ])
                          ])
                        ])
                      ], -1),
                      _createElementVNode("span", null, "Edit Module", -1)
                    ]), 8, _hoisted_24),
                    _createElementVNode("button", {
                      class: "flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-red-500 bg-white border border-red-400 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                      type: "button",
                      onClick: ($event: any) => (_ctx.openDeleteModuleModal(module._id))
                    }, _cache[25] || (_cache[25] = [
                      _createElementVNode("svg", {
                        class: "w-5 h-5 mr-2",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", {
                          id: "SVGRepo_bgCarrier",
                          "stroke-width": "0"
                        }),
                        _createElementVNode("g", {
                          id: "SVGRepo_tracerCarrier",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                          _createElementVNode("path", {
                            d: "M4 7H20",
                            stroke: "#ff5c5c",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                          }),
                          _createElementVNode("path", {
                            d: "M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10",
                            stroke: "#ff5c5c",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                          }),
                          _createElementVNode("path", {
                            d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z",
                            stroke: "#ff5c5c",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                          })
                        ])
                      ], -1),
                      _createElementVNode("span", null, "Delete Module", -1)
                    ]), 8, _hoisted_25)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[28] || (_cache[28] = _createElementVNode("div", null, [
                        _createElementVNode("h5", { class: "mr-3 font-semibold dark:text-white" }, " Contents ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("button", {
                          class: "flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-white rounded-lg md:w-auto bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800",
                          type: "button",
                          onClick: ($event: any) => (_ctx.openNewContentModal(module._id))
                        }, _cache[27] || (_cache[27] = [
                          _createElementVNode("svg", {
                            "aria-hidden": "true",
                            class: "h-3.5 w-3.5 mr-2",
                            fill: "currentColor",
                            viewBox: "0 0 20 20",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              "clip-rule": "evenodd",
                              d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                              "fill-rule": "evenodd"
                            })
                          ], -1),
                          _createElementVNode("span", null, "New Content", -1)
                        ]), 8, _hoisted_30)
                      ])
                    ])
                  ]),
                  _createVNode(_component_draggable, {
                    modelValue: module.contents,
                    "onUpdate:modelValue": ($event: any) => ((module.contents) = $event),
                    onChange: ($event: any) => (_ctx.orderContents(module))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.contents, (content, contentIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: contentIndex,
                          class: "content-item flex items-center py-2 bg-white hover:bg-gray-100 cursor-pointer justify-between rounded-lg border border-gray-200 mt-2 pr-2"
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex items-center mx-1" }, [
                              _createElementVNode("svg", {
                                class: "w-auto h-6 float-right rotate-180 fill-gray-300 shrink-0",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", {
                                  id: "SVGRepo_bgCarrier",
                                  "stroke-width": "0"
                                }),
                                _createElementVNode("g", {
                                  id: "SVGRepo_tracerCarrier",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                  _createElementVNode("path", { d: "M16 17C17.1046 17 18 17.8954 18 19C18 20.1046 17.1046 21 16 21C14.8954 21 14 20.1046 14 19C14 17.8954 14.8954 17 16 17ZM8 17C9.10457 17 10 17.8954 10 19C10 20.1046 9.10457 21 8 21C6.89543 21 6 20.1046 6 19C6 17.8954 6.89543 17 8 17ZM16 10C17.1046 10 18 10.8954 18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10ZM8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12C6 10.8954 6.89543 10 8 10ZM16 3C17.1046 3 18 3.89543 18 5C18 6.10457 17.1046 7 16 7C14.8954 7 14 6.10457 14 5C14 3.89543 14.8954 3 16 3ZM8 3C9.10457 3 10 3.89543 10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3Z" })
                                ])
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, [
                                (content.type === 'video')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_34, _cache[29] || (_cache[29] = [
                                      _createElementVNode("g", {
                                        id: "SVGRepo_bgCarrier",
                                        "stroke-width": "0"
                                      }, null, -1),
                                      _createElementVNode("g", {
                                        id: "SVGRepo_tracerCarrier",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, null, -1),
                                      _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                        _createElementVNode("path", {
                                          d: "M6 9.32993V14.6699C6 17.9899 8.35 19.3399 11.22 17.6899L12.5 16.9499C12.81 16.7699 13 16.4399 13 16.0799V7.91993C13 7.55993 12.81 7.22993 12.5 7.04993L11.22 6.30992C8.35 4.65992 6 6.00993 6 9.32993Z",
                                          fill: "#000000"
                                        }),
                                        _createTextVNode(),
                                        _createElementVNode("path", {
                                          d: "M14 8.79006V15.2201C14 15.6101 14.42 15.8501 14.75 15.6501L15.85 15.0101C18.72 13.3601 18.72 10.6401 15.85 8.99006L14.75 8.35006C14.42 8.16006 14 8.40006 14 8.79006Z",
                                          fill: "#000000",
                                          opacity: "0.4"
                                        })
                                      ], -1)
                                    ])))
                                  : (content.type === 'article')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_35, _cache[30] || (_cache[30] = [
                                        _createElementVNode("g", {
                                          id: "SVGRepo_bgCarrier",
                                          "stroke-width": "0"
                                        }, null, -1),
                                        _createElementVNode("g", {
                                          id: "SVGRepo_tracerCarrier",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, null, -1),
                                        _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                          _createElementVNode("path", {
                                            d: "M12 5.29994V21.3299C11.83 21.3299 11.65 21.2999 11.51 21.2199L11.47 21.1999C9.55 20.1499 6.2 19.0499 4.03 18.7599L3.74 18.7199C2.78 18.5999 2 17.6999 2 16.7399V4.65994C2 3.46994 2.97 2.56994 4.16 2.66994C6.26 2.83994 9.44 3.89994 11.22 5.00994L11.47 5.15994C11.62 5.24994 11.81 5.29994 12 5.29994Z",
                                            fill: "#000000",
                                            opacity: "0.4"
                                          }),
                                          _createTextVNode(),
                                          _createElementVNode("path", {
                                            d: "M22 4.67003V16.74C22 17.7 21.22 18.6 20.26 18.72L19.93 18.76C17.75 19.05 14.39 20.16 12.47 21.22C12.34 21.3 12.18 21.33 12 21.33V5.30003C12.19 5.30003 12.38 5.25003 12.53 5.16003L12.7 5.05003C14.48 3.93003 17.67 2.86003 19.77 2.68003H19.83C21.02 2.58003 22 3.47003 22 4.67003Z",
                                            fill: "#000000"
                                          }),
                                          _createTextVNode(),
                                          _createElementVNode("path", {
                                            d: "M7.75 9.23999H5.5C5.09 9.23999 4.75 8.89999 4.75 8.48999C4.75 8.07999 5.09 7.73999 5.5 7.73999H7.75C8.16 7.73999 8.5 8.07999 8.5 8.48999C8.5 8.89999 8.16 9.23999 7.75 9.23999Z",
                                            fill: "#000000"
                                          }),
                                          _createTextVNode(),
                                          _createElementVNode("path", {
                                            d: "M8.5 12.24H5.5C5.09 12.24 4.75 11.9 4.75 11.49C4.75 11.08 5.09 10.74 5.5 10.74H8.5C8.91 10.74 9.25 11.08 9.25 11.49C9.25 11.9 8.91 12.24 8.5 12.24Z",
                                            fill: "#000000"
                                          })
                                        ], -1)
                                      ])))
                                    : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("h2", _hoisted_36, _toDisplayString(content.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(content.length) + " dakika", 1),
                            _createElementVNode("button", {
                              class: "flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-black bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-gray-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                              type: "button",
                              onClick: ($event: any) => (_ctx.openDeleteContentModal(content._id))
                            }, _cache[32] || (_cache[32] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", {
                                  id: "SVGRepo_bgCarrier",
                                  "stroke-width": "0"
                                }),
                                _createElementVNode("g", {
                                  id: "SVGRepo_tracerCarrier",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                  _createElementVNode("path", {
                                    d: "M4 7H20",
                                    stroke: "#000000",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10",
                                    stroke: "#000000",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z",
                                    stroke: "#000000",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2"
                                  })
                                ])
                              ], -1)
                            ]), 8, _hoisted_39),
                            _createElementVNode("button", {
                              class: "flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-black bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-gray-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                              type: "button",
                              onClick: ($event: any) => (_ctx.openUpdateContentModal(content._id))
                            }, _cache[33] || (_cache[33] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5 mr-2",
                                fill: "#000000",
                                viewBox: "0 0 32 32",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", {
                                  id: "SVGRepo_bgCarrier",
                                  "stroke-width": "0"
                                }),
                                _createElementVNode("g", {
                                  id: "SVGRepo_tracerCarrier",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                  _createElementVNode("path", { d: "m16 0c8.836556 0 16 7.163444 16 16s-7.163444 16-16 16-16-7.163444-16-16 7.163444-16 16-16zm0 2c-7.7319865 0-14 6.2680135-14 14s6.2680135 14 14 14 14-6.2680135 14-14-6.2680135-14-14-14zm1.3 18.5v2.6h-2.6v-2.6zm-1.3-11.5c2.209139 0 4 1.790861 4 4 0 1.8636009-1.2744465 3.4295388-2.9993376 3.873812l-.0006624 2.126188h-2v-4h1c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2c-1.0543618 0-1.9181651.8158778-1.9945143 1.8507377l-.0054857.1492623h-2c0-2.209139 1.790861-4 4-4z" })
                                ])
                              ], -1),
                              _createElementVNode("span", null, "Details", -1)
                            ]), 8, _hoisted_40)
                          ]),
                          _createVNode(_component_Modal, {
                            "is-visible": _ctx.modals[`updateContent${content._id}`] || false,
                            "modal-id": `updateContent${content._id}`,
                            "onUpdate:isVisible": value => _ctx.modals[`updateContent${content._id}`] = value
                          }, {
                            body: _withCtx(() => [
                              _createElementVNode("div", _hoisted_41, [
                                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
                                  _createElementVNode("svg", {
                                    class: "w-52",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("g", {
                                      id: "SVGRepo_bgCarrier",
                                      "stroke-width": "0"
                                    }),
                                    _createElementVNode("g", {
                                      id: "SVGRepo_tracerCarrier",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }),
                                    _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                      _createElementVNode("path", {
                                        d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z",
                                        fill: "#000000",
                                        opacity: "0.4"
                                      }),
                                      _createElementVNode("path", {
                                        d: "M19.0206 3.48016C17.0806 1.54016 15.1806 1.49016 13.1906 3.48016L11.9806 4.69016C11.8806 4.79016 11.8406 4.95016 11.8806 5.09016C12.6406 7.74016 14.7606 9.86016 17.4106 10.6202C17.4506 10.6302 17.4906 10.6402 17.5306 10.6402C17.6406 10.6402 17.7406 10.6002 17.8206 10.5202L19.0206 9.31016C20.0106 8.33016 20.4906 7.38016 20.4906 6.42016C20.5006 5.43016 20.0206 4.47016 19.0206 3.48016Z",
                                        fill: "#000000",
                                        opacity: "0.4"
                                      }),
                                      _createElementVNode("path", {
                                        d: "M15.6103 11.5298C15.3203 11.3898 15.0403 11.2498 14.7703 11.0898C14.5503 10.9598 14.3403 10.8198 14.1303 10.6698C13.9603 10.5598 13.7603 10.3998 13.5703 10.2398C13.5503 10.2298 13.4803 10.1698 13.4003 10.0898C13.0703 9.8098 12.7003 9.4498 12.3703 9.0498C12.3403 9.0298 12.2903 8.9598 12.2203 8.8698C12.1203 8.7498 11.9503 8.5498 11.8003 8.3198C11.6803 8.1698 11.5403 7.9498 11.4103 7.7298C11.2503 7.4598 11.1103 7.1898 10.9703 6.9098C10.8303 6.6098 10.7203 6.3198 10.6203 6.0498L4.34032 12.3298C4.21032 12.4598 4.09032 12.7098 4.06032 12.8798L3.52032 16.7098C3.42032 17.3898 3.61032 18.0298 4.03032 18.4598C4.39032 18.8098 4.89032 18.9998 5.43032 18.9998C5.55032 18.9998 5.67032 18.9898 5.79032 18.9698L9.63032 18.4298C9.81032 18.3998 10.0603 18.2798 10.1803 18.1498L16.4603 11.8698C16.1803 11.7698 15.9103 11.6598 15.6103 11.5298Z",
                                        fill: "#000000"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("h2", { class: "block text-2xl font-bold text-gray-800 dark:text-gray-200" }, " Update Content "),
                                  _createElementVNode("p", { class: "mt-2 text-sm text-gray-600 dark:text-gray-400" }, " You are updating this content. ")
                                ], -1)),
                                _createElementVNode("div", _hoisted_42, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "newModuleTitle",
                                    "onUpdate:modelValue": ($event: any) => ((content.title) = $event),
                                    class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2",
                                    placeholder: "Enter the content name",
                                    type: "text"
                                  }, null, 8, _hoisted_43), [
                                    [_vModelText, content.title]
                                  ]),
                                  _cache[34] || (_cache[34] = _createElementVNode("label", {
                                    class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                                    for: "newModuleTitle"
                                  }, "Content title", -1))
                                ]),
                                (content.type === 'video')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _withDirectives(_createElementVNode("input", {
                                        id: "contentLength",
                                        "onUpdate:modelValue": ($event: any) => ((content.length) = $event),
                                        class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2",
                                        placeholder: "Enter the content length in minute",
                                        type: "text"
                                      }, null, 8, _hoisted_45), [
                                        [_vModelText, content.length]
                                      ]),
                                      _cache[35] || (_cache[35] = _createElementVNode("label", {
                                        class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                                        for: "contentLength"
                                      }, "Content length (min)", -1))
                                    ]))
                                  : _createCommentVNode("", true),
                                (content.type === 'video')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": ($event: any) => ((content.description) = $event),
                                        class: "py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                                        placeholder: "Please describe this content...",
                                        rows: "3",
                                        type: "text"
                                      }, null, 8, _hoisted_47), [
                                        [_vModelText, content.description]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (content.type === 'video')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                      _createElementVNode("input", {
                                        accept: "video/*",
                                        class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                                        type: "file",
                                        onChange: (event) => _ctx.handleContentVideoUpload(event, content)
                                      }, null, 40, _hoisted_49),
                                      _cache[36] || (_cache[36] = _createElementVNode("label", {
                                        class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                                        for: "newContentVideoUrl"
                                      }, "Video URL", -1))
                                    ]))
                                  : _createCommentVNode("", true),
                                (content.type === 'video')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      (_ctx.getContentVideoPreviewState(content._id).status === 'loading')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, " Loading video preview... "))
                                        : (_ctx.getContentVideoPreviewState(content._id).status === 'error')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.getContentVideoPreviewState(content._id).error), 1))
                                          : (_ctx.getContentVideoPreviewState(content._id).status === 'ready')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                _createElementVNode("video", {
                                                  class: "w-full rounded-lg border border-gray-200",
                                                  controls: "",
                                                  src: _ctx.getContentVideoPreviewState(content._id).url
                                                }, null, 8, _hoisted_54),
                                                _createElementVNode("button", {
                                                  class: "text-xs font-semibold text-red-600 hover:text-red-700",
                                                  type: "button",
                                                  onClick: ($event: any) => (_ctx.removeContentVideo(content))
                                                }, " Remove video ", 8, _hoisted_55)
                                              ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (content.type === 'video' && content.videoUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, " Current video: " + _toDisplayString(_ctx.formatVideoLabel(content.videoUrl)), 1))
                                  : _createCommentVNode("", true),
                                (content.type === 'video')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      (_ctx.getContentVideoUploadState(content._id).status === 'uploading')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, " Uploading video... " + _toDisplayString(_ctx.getContentVideoUploadState(content._id).progress) + "% ", 1))
                                        : (_ctx.getContentVideoUploadState(content._id).status === 'success')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, " Video uploaded successfully. "))
                                          : (_ctx.getContentVideoUploadState(content._id).status === 'error')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.getContentVideoUploadState(content._id).error), 1))
                                            : _createCommentVNode("", true),
                                      (_ctx.getContentVideoUploadState(content._id).status === 'uploading')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                            _createElementVNode("div", {
                                              class: "h-2 rounded-full bg-black transition-all",
                                              style: _normalizeStyle({ width: `${_ctx.getContentVideoUploadState(content._id).progress}%` })
                                            }, null, 4)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (content.type === 'article')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": ($event: any) => ((content.body) = $event),
                                        class: "py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                                        placeholder: "Please describe this module...",
                                        rows: "3"
                                      }, null, 8, _hoisted_63), [
                                        [_vModelText, content.body]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("button", {
                                  class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.closeModal(`updateContent${content._id}`))
                                }, " Cancel ", 8, _hoisted_65),
                                _createElementVNode("button", {
                                  class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                                  type: "button",
                                  disabled: _ctx.getContentVideoUploadState(content._id).status === 'uploading',
                                  onClick: ($event: any) => (_ctx.updateContent(module._id,content))
                                }, " Update ", 8, _hoisted_66)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["is-visible", "modal-id", "onUpdate:isVisible"]),
                          _createVNode(_component_Modal, {
                            "is-visible": _ctx.modals[`deleteContent${content._id}`] || false,
                            "modal-id": `deleteContent${content._id}`,
                            "onUpdate:isVisible": value => _ctx.modals[`deleteContent${content._id}`] = value
                          }, {
                            body: _withCtx(() => _cache[38] || (_cache[38] = [
                              _createElementVNode("div", { class: "p-4 sm:p-10 overflow-y-auto" }, [
                                _createElementVNode("div", { class: "flex gap-x-4 md:gap-x-7" }, [
                                  _createElementVNode("span", { class: "flex-shrink-0 inline-flex justify-center items-center size-[46px] sm:w-[62px] sm:h-[62px] rounded-full border-4 border-red-50 bg-red-100 text-red-500 dark:bg-red-700 dark:border-red-600 dark:text-red-100" }, [
                                    _createElementVNode("svg", {
                                      class: "flex-shrink-0 size-5",
                                      fill: "currentColor",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      width: "16",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "grow" }, [
                                    _createElementVNode("h3", { class: "mb-2 text-xl font-bold text-gray-800 dark:text-gray-200" }, " Delete Module Content "),
                                    _createElementVNode("p", { class: "text-gray-500" }, " Permanently remove the selected content and all its data from the course module. This action cannot be undone. ")
                                  ])
                                ])
                              ], -1)
                            ])),
                            footer: _withCtx(() => [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("button", {
                                  class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.closeModal(`deleteContent${content._id}`))
                                }, " Cancel ", 8, _hoisted_68),
                                _createElementVNode("button", {
                                  class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.deleteContent(module._id, content._id))
                                }, " Delete ", 8, _hoisted_69)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["is-visible", "modal-id", "onUpdate:isVisible"])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ], 8, _hoisted_21), [
                [_vShow, module.show]
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.modules, (module, moduleIndex) => {
        return (_openBlock(), _createBlock(_component_Modal, {
          key: moduleIndex,
          "is-visible": _ctx.modals[`newContent${module._id}`] || false,
          "modal-id": `newContent${module._id}`,
          "onUpdate:isVisible": value => _ctx.modals[`newContent${module._id}`] = value
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_70, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
                _createElementVNode("svg", {
                  class: "w-52",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("g", {
                    id: "SVGRepo_bgCarrier",
                    "stroke-width": "0"
                  }),
                  _createElementVNode("g", {
                    id: "SVGRepo_tracerCarrier",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                    _createElementVNode("path", {
                      d: "M15.5 13.15H13.33C11.55 13.15 10.1 11.71 10.1 9.92V7.75C10.1 7.34 9.77 7 9.35 7H6.18C3.87 7 2 8.5 2 11.18V17.82C2 20.5 3.87 22 6.18 22H12.07C14.38 22 16.25 20.5 16.25 17.82V13.9C16.25 13.48 15.91 13.15 15.5 13.15Z",
                      fill: "#292D32",
                      opacity: "0.4"
                    }),
                    _createElementVNode("path", {
                      d: "M17.8198 2H15.8498H14.7598H11.9298C9.66977 2 7.83977 3.44 7.75977 6.01C7.81977 6.01 7.86977 6 7.92977 6H10.7598H11.8498H13.8198C16.1298 6 17.9998 7.5 17.9998 10.18V12.15V14.86V16.83C17.9998 16.89 17.9898 16.94 17.9898 16.99C20.2198 16.92 21.9998 15.44 21.9998 12.83V10.86V8.15V6.18C21.9998 3.5 20.1298 2 17.8198 2Z",
                      fill: "#292D32"
                    }),
                    _createElementVNode("path", {
                      d: "M11.9806 7.15024C11.6706 6.84024 11.1406 7.05024 11.1406 7.48024V10.1002C11.1406 11.2002 12.0706 12.1002 13.2106 12.1002C13.9206 12.1102 14.9106 12.1102 15.7606 12.1102C16.1906 12.1102 16.4106 11.6102 16.1106 11.3102C15.0206 10.2202 13.0806 8.27024 11.9806 7.15024Z",
                      fill: "#292D32"
                    })
                  ])
                ]),
                _createElementVNode("h2", { class: "block text-2xl font-bold text-gray-800 dark:text-gray-200" }, " Add New Content "),
                _createElementVNode("p", { class: "mt-2 text-sm text-gray-600 dark:text-gray-400" }, " You are creating new content for this module. ")
              ], -1)),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("ul", _hoisted_72, [
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "content-video",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newContent.type) = $event)),
                      class: "hidden peer",
                      name: "content-type",
                      required: "",
                      type: "radio",
                      value: "video"
                    }, null, 512), [
                      [_vModelRadio, _ctx.newContent.type]
                    ]),
                    _cache[39] || (_cache[39] = _createElementVNode("label", {
                      class: "inline-flex items-center justify-between w-full p-5 text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-gray-500 peer-checked:border-gray-600 peer-checked:text-gray-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700",
                      for: "content-video"
                    }, [
                      _createElementVNode("span", { class: "block" }, [
                        _createElementVNode("span", { class: "w-full text-lg font-semibold" }, "Video")
                      ]),
                      _createElementVNode("svg", {
                        "aria-hidden": "true",
                        class: "w-5 h-5 ms-3",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M15 10l4.55-3.27A1 1 0 0121 7.76v8.48a1 1 0 01-1.45.87L15 14v2a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h8a2 2 0 012 2v2z",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2"
                        })
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("li", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "content-type-article",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newContent.type) = $event)),
                      class: "hidden peer",
                      name: "content-type",
                      type: "radio",
                      value: "article"
                    }, null, 512), [
                      [_vModelRadio, _ctx.newContent.type]
                    ]),
                    _cache[40] || (_cache[40] = _createElementVNode("label", {
                      class: "inline-flex items-center justify-between w-full p-5 text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-gray-500 peer-checked:border-gray-600 peer-checked:text-gray-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700",
                      for: "content-type-article"
                    }, [
                      _createElementVNode("span", { class: "block" }, [
                        _createElementVNode("span", { class: "w-full text-lg font-semibold" }, "Makale")
                      ]),
                      _createElementVNode("svg", {
                        "aria-hidden": "true",
                        class: "w-5 h-5 ms-3",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M5 3v18l7-3 7 3V3z",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2"
                        })
                      ])
                    ], -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _withDirectives(_createElementVNode("input", {
                  id: "newModuleTitle",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newContent.title) = $event)),
                  class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2",
                  placeholder: "Enter the content name",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.newContent.title]
                ]),
                _cache[41] || (_cache[41] = _createElementVNode("label", {
                  class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                  for: "newModuleTitle"
                }, "Content Title", -1))
              ]),
              (_ctx.newContent.type === 'video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", {
                      class: "sr-only",
                      for: "file-input"
                    }, "Video File", -1)),
                    _createElementVNode("input", {
                      id: "file-input",
                      accept: "video/*",
                      class: "block w-full border border-gray-200 shadow-sm rounded-lg text-sm focus:z-10 focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 file:bg-gray-50 file:border-0 file:me-4 file:py-3 file:px-4 dark:file:bg-neutral-700 dark:file:text-neutral-400",
                      name: "file-input",
                      type: "file",
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleVideoUpload && _ctx.handleVideoUpload(...args)))
                    }, null, 32)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.newContent.type === 'video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    (_ctx.newVideoPreview.status === 'loading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, " Loading video preview... "))
                      : (_ctx.newVideoPreview.status === 'error')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.newVideoPreview.error), 1))
                        : (_ctx.newVideoPreview.status === 'ready')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _createElementVNode("video", {
                                class: "w-full rounded-lg border border-gray-200",
                                controls: "",
                                src: _ctx.newVideoPreview.url
                              }, null, 8, _hoisted_79),
                              _createElementVNode("button", {
                                class: "text-xs font-semibold text-red-600 hover:text-red-700",
                                type: "button",
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.removeNewVideo && _ctx.removeNewVideo(...args)))
                              }, " Remove video ")
                            ]))
                          : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.newContent.type === 'video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    (_ctx.newVideoUpload.status === 'uploading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, " Uploading video... " + _toDisplayString(_ctx.newVideoUpload.progress) + "% ", 1))
                      : (_ctx.newVideoUpload.status === 'success')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, " Video uploaded successfully. "))
                        : (_ctx.newVideoUpload.status === 'error')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(_ctx.newVideoUpload.error), 1))
                          : _createCommentVNode("", true),
                    (_ctx.newVideoUpload.status === 'uploading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", {
                            class: "h-2 rounded-full bg-black transition-all",
                            style: _normalizeStyle({ width: `${_ctx.newVideoUpload.progress}%` })
                          }, null, 4)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_85, [
                _withDirectives(_createElementVNode("input", {
                  id: "contentLength",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newContent.length) = $event)),
                  class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2",
                  placeholder: "Enter the content length in minute",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.newContent.length]
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("label", {
                  class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                  for: "contentLength"
                }, "Content length (min)", -1))
              ]),
              _createElementVNode("div", _hoisted_86, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newContent.description) = $event)),
                  class: "py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                  placeholder: "Please describe this content...",
                  rows: "3",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.newContent.description]
                ])
              ]),
              (_ctx.newContent.type === 'article')
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newContent.body) = $event)),
                      class: "py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                      placeholder: "Please describe this content...",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _ctx.newContent.body]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("button", {
                class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                type: "button",
                onClick: ($event: any) => (_ctx.closeModal(`newContent${module._id}`))
              }, " Cancel ", 8, _hoisted_89),
              _createElementVNode("button", {
                class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                type: "button",
                disabled: _ctx.newVideoUpload.status === 'uploading',
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.createContent && _ctx.createContent(...args)))
              }, " Create ", 8, _hoisted_90)
            ])
          ]),
          _: 2
        }, 1032, ["is-visible", "modal-id", "onUpdate:isVisible"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.modules, (module, index) => {
        return (_openBlock(), _createBlock(_component_Modal, {
          key: index,
          "is-visible": _ctx.modals[`updateModule${module._id}`] || false,
          "modal-id": `updateModule${module._id}`,
          "onUpdate:isVisible": value => _ctx.modals[`updateModule${module._id}`] = value
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_91, [
              _cache[46] || (_cache[46] = _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
                _createElementVNode("svg", {
                  class: "w-52",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("g", {
                    id: "SVGRepo_bgCarrier",
                    "stroke-width": "0"
                  }),
                  _createElementVNode("g", {
                    id: "SVGRepo_tracerCarrier",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                    _createElementVNode("path", {
                      d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z",
                      fill: "#000000",
                      opacity: "0.4"
                    }),
                    _createElementVNode("path", {
                      d: "M19.0206 3.48016C17.0806 1.54016 15.1806 1.49016 13.1906 3.48016L11.9806 4.69016C11.8806 4.79016 11.8406 4.95016 11.8806 5.09016C12.6406 7.74016 14.7606 9.86016 17.4106 10.6202C17.4506 10.6302 17.4906 10.6402 17.5306 10.6402C17.6406 10.6402 17.7406 10.6002 17.8206 10.5202L19.0206 9.31016C20.0106 8.33016 20.4906 7.38016 20.4906 6.42016C20.5006 5.43016 20.0206 4.47016 19.0206 3.48016Z",
                      fill: "#000000",
                      opacity: "0.4"
                    }),
                    _createElementVNode("path", {
                      d: "M15.6103 11.5298C15.3203 11.3898 15.0403 11.2498 14.7703 11.0898C14.5503 10.9598 14.3403 10.8198 14.1303 10.6698C13.9603 10.5598 13.7603 10.3998 13.5703 10.2398C13.5503 10.2298 13.4803 10.1698 13.4003 10.0898C13.0703 9.8098 12.7003 9.4498 12.3703 9.0498C12.3403 9.0298 12.2903 8.9598 12.2203 8.8698C12.1203 8.7498 11.9503 8.5498 11.8003 8.3198C11.6803 8.1698 11.5403 7.9498 11.4103 7.7298C11.2503 7.4598 11.1103 7.1898 10.9703 6.9098C10.8303 6.6098 10.7203 6.3198 10.6203 6.0498L4.34032 12.3298C4.21032 12.4598 4.09032 12.7098 4.06032 12.8798L3.52032 16.7098C3.42032 17.3898 3.61032 18.0298 4.03032 18.4598C4.39032 18.8098 4.89032 18.9998 5.43032 18.9998C5.55032 18.9998 5.67032 18.9898 5.79032 18.9698L9.63032 18.4298C9.81032 18.3998 10.0603 18.2798 10.1803 18.1498L16.4603 11.8698C16.1803 11.7698 15.9103 11.6598 15.6103 11.5298Z",
                      fill: "#000000"
                    })
                  ])
                ]),
                _createElementVNode("h2", { class: "block text-2xl font-bold text-gray-800 dark:text-gray-200" }, " Update Module "),
                _createElementVNode("p", { class: "mt-2 text-sm text-gray-600 dark:text-gray-400" }, " You are updating this module. ")
              ], -1)),
              _createElementVNode("div", _hoisted_92, [
                _withDirectives(_createElementVNode("input", {
                  id: "updateModuleTitle",
                  "onUpdate:modelValue": ($event: any) => ((module.title) = $event),
                  class: "peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2",
                  placeholder: "Enter the module name",
                  type: "text"
                }, null, 8, _hoisted_93), [
                  [_vModelText, module.title]
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("label", {
                  class: "absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500",
                  for: "updateModuleTitle"
                }, "Module title", -1))
              ]),
              _createElementVNode("div", _hoisted_94, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": ($event: any) => ((module.description) = $event),
                  class: "py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600",
                  placeholder: "Please describe this module...",
                  rows: "3",
                  type: "text"
                }, null, 8, _hoisted_95), [
                  [_vModelText, module.description]
                ])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("button", {
                class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                type: "button",
                onClick: ($event: any) => (_ctx.closeModal(`updateModule${module._id}`))
              }, " Cancel ", 8, _hoisted_97),
              _createElementVNode("button", {
                class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                type: "button",
                onClick: ($event: any) => (_ctx.updateModule(module))
              }, " Update ", 8, _hoisted_98)
            ])
          ]),
          _: 2
        }, 1032, ["is-visible", "modal-id", "onUpdate:isVisible"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.modules, (module, index) => {
        return (_openBlock(), _createBlock(_component_Modal, {
          key: index,
          "is-visible": _ctx.modals[`deleteModule${module._id}`] || false,
          "modal-id": `deleteModule${module._id}`,
          "onUpdate:isVisible": value => _ctx.modals[`deleteModule${module._id}`] = value
        }, {
          body: _withCtx(() => _cache[47] || (_cache[47] = [
            _createElementVNode("div", { class: "p-4 sm:p-10 overflow-y-auto" }, [
              _createElementVNode("div", { class: "flex gap-x-4 md:gap-x-7" }, [
                _createElementVNode("span", { class: "flex-shrink-0 inline-flex justify-center items-center size-[46px] sm:w-[62px] sm:h-[62px] rounded-full border-4 border-red-50 bg-red-100 text-red-500 dark:bg-red-700 dark:border-red-600 dark:text-red-100" }, [
                  _createElementVNode("svg", {
                    class: "flex-shrink-0 size-5",
                    fill: "currentColor",
                    height: "16",
                    viewBox: "0 0 16 16",
                    width: "16",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
                  ])
                ]),
                _createElementVNode("div", { class: "grow" }, [
                  _createElementVNode("h3", { class: "mb-2 text-xl font-bold text-gray-800 dark:text-gray-200" }, " Delete Course Module "),
                  _createElementVNode("p", { class: "text-gray-500" }, " Permanently remove the selected module and all its content from the course. This action cannot be undone. ")
                ])
              ])
            ], -1)
          ])),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("button", {
                class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                type: "button",
                onClick: ($event: any) => (_ctx.closeModal(`deleteModule${module._id}`))
              }, " Cancel ", 8, _hoisted_100),
              _createElementVNode("button", {
                class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                type: "button",
                onClick: ($event: any) => (_ctx.deleteModule(module._id))
              }, " Delete ", 8, _hoisted_101)
            ])
          ]),
          _: 2
        }, 1032, ["is-visible", "modal-id", "onUpdate:isVisible"]))
      }), 128))
    ])
  ]))
}